import { getS3FileContent } from "@/pages/api/cache-pages";
import { AWS_STRAPI_JSON_DATA_FOLDER_NAME } from "@/utils/utils";
import axios, { AxiosInstance } from "axios";

export const api: AxiosInstance = axios.create({
  baseURL:
    process.env.ENV_NAME === "development"
      ? process.env.CMS_API_BASE_URL_QA
      : process.env.ENV_NAME === "release"
      ? process.env.CMS_API_BASE_URL_UAT
      : process.env.CMS_API_BASE_URL_PROD,
});

export const fetchSingleTypeData = async (): Promise<any> => {
  try {
    const response = await api.get(`api/home-page`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching data from home-page:`, error);
    const HomeData = await getS3FileContent(
      `${AWS_STRAPI_JSON_DATA_FOLDER_NAME}/home-page.json`
    );
    return HomeData;
  }
};

export const CmsCoursePages = async (param: string): Promise<any> => {
  try {
    const response = await api.get(
      `api/program-detail-pages?filters[slug][$eq]=${param}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching CMS data:", error);
    const response = await getS3FileContent(
      `${AWS_STRAPI_JSON_DATA_FOLDER_NAME}/program-detail-pages.json`
    );
    return response;
  }
};

export const CmsAllCousesList = async (): Promise<any> => {
  try {
    const response = await api.get(`api/program-detail-pages`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching data from home-page:`, error);
    const response = await getS3FileContent(
      `${AWS_STRAPI_JSON_DATA_FOLDER_NAME}/program-detail-pages.json`
    );
    return response;
  }
};

export const CmsSchoolPages = async (params: string): Promise<any> => {
  try {
    const response = await api.get(
      `api/school-pages?filters[slug][$eq]=${params}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching CMS data:", error);
    const response = await getS3FileContent(
      `${AWS_STRAPI_JSON_DATA_FOLDER_NAME}/school-pages.json`
    );
    return response;
  }
};

export const fetchContactData = async (): Promise<any> => {
  try {
    const response = await api.get(`api/contact-us`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching data from contact-page:`, error);
    const ContactData = await getS3FileContent(
      `${AWS_STRAPI_JSON_DATA_FOLDER_NAME}/contact-us.json`
    );
    return ContactData;
  }
};

export const fetchAboutData = async (): Promise<any> => {
  try {
    const response = await api.get(`api/about-us`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching data from about-page:`, error);
    throw error;
  }
};

export const fetchAccreditationData = async (): Promise<any> => {
  try {
    const response = await api.get(`api/accreditations-page`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching data from accreditiation-page:`, error);
    const AccreditationsData = await getS3FileContent(
      `${AWS_STRAPI_JSON_DATA_FOLDER_NAME}/accreditations-page.json`
    );
    return AccreditationsData;
  }
};

export const fetchLeadershipPageData = async (): Promise<any> => {
  try {
    const response = await api.get(`api/leadership-page`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching data from accreditiation-page:`, error);
    const LeadershipData = await getS3FileContent(
      `${AWS_STRAPI_JSON_DATA_FOLDER_NAME}/leadership-page.json`
    );
    return LeadershipData;
  }
};

export const CmsUgpgPages = async (params: string): Promise<any> => {
  try {
    const response = await api.get(`api/ug-pgs?filters[slug][$eq]=${params}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching CMS data:", error);
    const response = await getS3FileContent(
      `${AWS_STRAPI_JSON_DATA_FOLDER_NAME}/ug-pgs.json`
    );
    return response;
  }
};

export const fetchAboutUsData = async (): Promise<any> => {
  try {
    const response = await api.get(`api/about-us`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching data from home-page:`, error);
    const AboutData = await getS3FileContent(
      `${AWS_STRAPI_JSON_DATA_FOLDER_NAME}/about-us.json`
    );
    return AboutData;
  }
};

export const fetchAllProgramPageData = async (): Promise<any> => {
  try {
    const response = await api.get(`api/all-programs-page
`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching data from home-page:`, error);
    const AllAcademicData = await getS3FileContent(
      `${AWS_STRAPI_JSON_DATA_FOLDER_NAME}/all-programs-page.json`
    );
    return AllAcademicData;
  }
};

export const fetchSchoolFundingData = async (): Promise<any> => {
  try {
    const response = await api.get(`api/student-funding-option`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching data from home-page:`, error);
    const StudentLoandData = await getS3FileContent(
      `${AWS_STRAPI_JSON_DATA_FOLDER_NAME}/student-funding-option.json`
    );
    return StudentLoandData;
  }
};

export const fetchAllProgramNamesList = async (): Promise<any> => {
  try {
    const response = await api.get(`api/program-of-interest`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching data from home-page:`, error);
    throw error;
  }
};

export default api;
